import { z } from 'zod';
import { LiliPlanType } from '@lili/lili-frontend-common';
import { fallback } from '@tanstack/zod-adapter';

export const planSelectionQueryParamsSchema = z.object({
  initialPlan: fallback(z.nativeEnum(LiliPlanType), LiliPlanType.CORE),
});

export type PlanSelectionQueryParams = z.infer<typeof planSelectionQueryParamsSchema>;
